<template>
  <div>
    <b-card
      class="mx-auto"
      style="max-width: 220px"
      v-if="productsToRender.length < 2"
    >
      <b-card-text class="d-flex flex-column align-items-center text-center">
        <i class="fas fa-info-circle fs-20 text-info mb-2"></i>
        Selecione no mínimo 2 produtos para gerar a imagem
      </b-card-text>
    </b-card>
    <div v-else>
      <div class="mb-4 d-flex align-items-center">
        <div>
          <b-button
            variant="success"
            title="Baixar a imagem em formato .jpeg"
            class="mr-2"
            @click="$emit('downloadImage')"
            :disabled="generatingImage"
          >
            <i class="fas fa-cloud-download-alt mr-1"></i>
            Baixar imagem
          </b-button>
          <b-button
            variant="warning"
            title="Excluir todas as alterações feitas"
            :disabled="generatingImage"
            @click="$emit('excludeEdit')"
          >
            <i class="fas fa-trash mr-1"></i>
            Excluir alterações
          </b-button>
        </div>

        <div class="text-center ml-5">
          <span
            class="fs-18"
            :class="productsToRender.length > limitOfProducts ? 'c-red' : ''"
          >
            <b>{{ productsToRender.length }}</b> produtos de
            <b>{{ limitOfProducts }}</b> selecionados.
          </span>
          <div class="fs-12" v-if="productsToRender.length > limitOfProducts">
            (Você selecionou mais produtos do que o sugerido)
          </div>
        </div>
      </div>
      <div
        id="digitalPromotionImageElementId"
        style="
          display: grid;
          grid-template-rows: 170px calc(100% - 250px) 80px;
          font-family: Roboto;
        "
        :style="`
          height: ${height}px;
          width: ${width}px;
          background: ${backgroundColor.hex};
          color: ${fontColor.hex};
        `"
        class="overflow-hidden"
      >
        <div
          v-if="!headerImage"
          :style="`background: ${headerColor.hex}`"
          class="d-flex flex-column align-items-center"
        >
          <div
            class="d-flex align-items-center justify-content-between mx-2 position-relative"
            style="width: 100%"
          >
            <img
              class="align-self-start"
              src="@/assets/img/promocoes-digitais/balao.png"
              height="140px"
              width="200px"
              style="object-fit: contain"
            />
            <div
              class="font-weight-bold fs-32 d-flex flex-column align-items-center text-center"
            >
              <img
                height="60px"
                width="200px"
                class="text-center mt-2"
                src="@/assets/img/promocoes-digitais/festa-junina.png"
                style="object-fit: contain"
              />
              <img
                class="text-center mt-2"
                :src="companyInfo.logoBase64"
                height="90px"
                width="200px"
                style="object-fit: contain"
              />
            </div>
            <img
              class="align-self-start"
              src="@/assets/img/promocoes-digitais/balao-2.png"
              height="140px"
              width="200px"
              style="object-fit: contain; z-index: 1"
            />
            <img
              width="200px"
              class="position-absolute"
              src="@/assets/img/promocoes-digitais/flags.png"
              style="
                object-fit: contain;
                right: -20px;
                top: 0;
                z-index: 0;
                transform: rotate(30deg);
              "
            />
            <div
              v-if="!generatingImage"
              class="position-absolute c-pointer"
              title="Mudar fundo do cabeçalho"
              style="
                top: 5px;
                right: 5px;
                background-color: white;
                padding: 6px 8px;
                border-radius: 50%;
                z-index: 1;
              "
              @click="changeHeaderImage"
            >
              <i class="far fa-edit fs-14 ml-1"></i>
            </div>
          </div>
        </div>
        <div
          v-else
          style="
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            position: relative;
          "
          :style="`background-image: url(${headerImage});`"
        >
          <div
            v-if="!generatingImage"
            class="position-absolute c-pointer"
            title="Remover fundo do cabeçalho"
            style="
              top: 5px;
              right: 5px;
              background-color: white;
              padding: 3px 8px;
              border-radius: 50%;
              z-index: 1;
            "
            @click="headerImage = null"
          >
            <i class="far fa-trash-alt fs-14 c-red"></i>
          </div>
        </div>
        <div
          class="d-flex align-items-center flex-wrap justify-content-center align-content-center overflow-hidden my-4 px-1"
          style="flex: 0 0 200px; gap: 20px"
        >
          <div
            v-for="product in productsToRender"
            :key="product.id"
            class="d-flex flex-column justify-content-between"
            style="
              background-color: white;
              border-radius: 4px;
              padding: 10px;
              width: 200px;
              height: 170px;
            "
          >
            <span class="text-justify" style="font-size: 15px">
              {{ product.product }}
            </span>
            <div class="d-flex align-items-center mt-auto">
              <img
                fluid
                style="max-height: 80px; max-width: 80px; object-fit: contain"
                :src="productsPhotos[product.id] || ''"
                height="80px"
              />
              <div class="ml-1">
                <div class="font-weight-bold">
                  <sub class="fs-10">R$</sub
                  ><span class="fs-24"
                    >{{
                      formatNumber(product.priceSalesFormat1)
                        .replace(/R\$/gi, '')
                        .trim()
                    }}
                  </span>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between fs-12 mt-auto py-2"
          :style="`background: ${headerColor.hex}`"
        >
          <div
            class="d-flex flex-column justify-content-between px-2 pb-2 mt-2"
          >
            <span class="mr-5">
              Vendas válidas somente para compras no aplicativo até
              {{
                untilDate
                  ? toDDMMYYYY(new Date(untilDate + ' 23:59:59'))
                  : 'N/A'
              }}
              ou enquanto durarem os estoques. Imagens meramente ilustrativas.
            </span>
            <div class="d-flex align-items-center">
              <span
                v-if="telephone && telephone.link"
                class="d-flex align-items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 0 512 512"
                  :fill="fontColor.hex"
                >
                  <path
                    d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                  />
                </svg>
                <span class="ml-1">{{ telephone.link }}</span>
              </span>
              <span class="mx-2" v-if="telephone && telephone.link">|</span>
              <span
                v-if="whatsapp && whatsapp.link"
                class="d-flex align-items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 0 448 512"
                  :fill="fontColor.hex"
                >
                  <path
                    d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                  />
                </svg>
                <span class="ml-1">{{ whatsapp.link }}</span>
              </span>
            </div>
          </div>
          <img
            class="text-center"
            src="@/assets/img/promocoes-digitais/milho.png"
            height="50px"
            width="200px"
            style="object-fit: contain"
          />
        </div>
      </div>
      <div class="mt-4 d-flex align-items-center">
        <div>
          <b-button
            variant="success"
            title="Baixar a imagem em formato .jpeg"
            class="mr-2"
            @click="$emit('downloadImage')"
            :disabled="generatingImage"
          >
            <i class="fas fa-cloud-download-alt mr-1"></i>
            Baixar imagem
          </b-button>
          <b-button
            variant="warning"
            title="Excluir todas as alterações feitas"
            :disabled="generatingImage"
            @click="$emit('excludeEdit')"
          >
            <i class="fas fa-trash mr-1"></i>
            Excluir alterações
          </b-button>
        </div>

        <div class="text-center ml-5">
          <span
            class="fs-18"
            :class="productsToRender.length > limitOfProducts ? 'c-red' : ''"
          >
            <b>{{ productsToRender.length }}</b> produtos de
            <b>{{ limitOfProducts }}</b> selecionados.
          </span>
          <div class="fs-12" v-if="productsToRender.length > limitOfProducts">
            (Você selecionou mais produtos do que o sugerido)
          </div>
        </div>
      </div>
      <b-overlay
        :show="generatingImage"
        rounded
        opacity="0.6"
        bg-color="black"
        spinner-variant="primary"
        no-wrap
      ></b-overlay>
    </div>

    <input
      hidden
      type="file"
      ref="fileInput"
      accept="image/*"
      @change="onFileChange"
    />
  </div>
</template>

<script>
import { convertFileToBase64, formatNumber } from '@/utils';
import { toDDMMYYYY } from '@/utils/date';

import SOCIAL_MEDIAS from 'Enums/SocialMedias.js';

export default {
  name: 'ImagePreview',
  emits: ['downloadImage', 'excludeEdit'],
  props: {
    id: {
      type: String,
      required: true,
    },
    companyInfo: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    productsToRender: {
      type: Array,
      default: () => [],
      required: true,
    },
    productsPhotos: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    height: {
      type: [Number, String],
      default: 800,
      required: true,
    },
    width: {
      type: [Number, String],
      default: 800,
      required: true,
    },
    backgroundColor: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    headerColor: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    fontColor: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    untilDate: {
      type: [String, Date],
      default: '',
    },
    socialMedias: {
      type: Array,
      default: () => [],
    },
    generatingImage: {
      type: Boolean,
      default: false,
    },
    limitOfProducts: {
      type: Number,
    },
  },
  data() {
    return {
      SOCIAL_MEDIAS,
      headerImage: null,
    };
  },
  computed: {
    whatsapp() {
      return this.socialMedias.find((x) => x.type === SOCIAL_MEDIAS.WHATSAPP);
    },
    telephone() {
      return this.socialMedias.find((x) => x.type === SOCIAL_MEDIAS.TELEPHONE);
    },
  },
  methods: {
    formatNumber,
    toDDMMYYYY,
    changeHeaderImage() {
      this.$refs.fileInput.click();
    },
    async onFileChange(event) {
      const file = event.target.files[0];
      const base64 = await convertFileToBase64(file);

      this.headerImage = base64;
      this.$refs.fileInput.value = null;
    },
  },
};
</script>

<style scoped>
.base-image {
  object-fit: contain;
}
</style>